export default __webpack_public_path__ + "static/media/secondary.bef4cf153d5acfc7c5bc4669ccf23194.svg";